import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  selected: "",
  disabled: "",
  value: ""
}
const _hoisted_2 = {
  key: 0,
  value: ""
}
const _hoisted_3 = ["value", "selected"]

import { SelectOption } from "@/@types";

type SelectProps = {
  hasError?: boolean;
  placeholder?: string;
  options: SelectOption[];
  showDefaultEmptyValue?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'Select',
  props: /*@__PURE__*/_mergeModels({
    hasError: { type: Boolean, default: false },
    placeholder: { default: "Selecione" },
    options: { default: () => ([]) },
    showDefaultEmptyValue: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const model = _useModel<string>(__props, "modelValue");



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    class: _normalizeClass(["form-select", {
      'is-invalid': _ctx.hasError,
    }])
  }, [
    _createElementVNode("option", _hoisted_1, _toDisplayString(_ctx.placeholder), 1),
    (_ctx.showDefaultEmptyValue)
      ? (_openBlock(), _createElementBlock("option", _hoisted_2, "Todos"))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createElementBlock("option", {
        value: option.value,
        selected: option.selected
      }, _toDisplayString(option.label), 9, _hoisted_3))
    }), 256))
  ], 2)), [
    [_vModelSelect, model.value]
  ])
}
}

})